<template>
  <div class="main" v-loading="loading">
    <div class="img"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/activity/activityfont.png" alt=""></div>
    <div class="bg">

      <div class="gift"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/activity/gift.gif" alt=""></div>
      <div class="gift one"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/activity/gift.gif" alt=""></div>
      <div class="gift two"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/activity/gift.gif" alt=""></div>
      <div class="gift three"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/activity/gift.gif" alt=""></div>
      <div class="gift four"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/activity/gift.gif" alt=""></div>
      <div class="gift five"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/activity/gift.gif" alt=""></div>

      <div class="box">
        <div class="form">
          <div class="title"></div>
          <el-form ref="form" :rules="rules" :model="form" label-position="top">
            <el-form-item label="姓名" prop="name">
              <el-input v-model="form.name" placeholder="请输入您的真实姓名"></el-input>
            </el-form-item>
            <el-form-item label="手机号码" prop="phone">
              <el-input v-model="form.phone" placeholder="请输入您的手机号码"></el-input>
            </el-form-item>
            <el-form-item label="邮箱" prop="email">
              <el-input v-model="form.email" placeholder="请输入您的电子邮箱"></el-input>
            </el-form-item>
            <el-form-item label="公司名称" prop="company">
              <el-input v-model="form.company" placeholder="请输入您的公司名称"></el-input>
            </el-form-item>
            <el-form-item label="职位" prop="position">
              <el-input v-model="form.position" placeholder="请输入您的职位"></el-input>
            </el-form-item>
          </el-form>

        </div>
      </div>
      <div class="true">
        <div class="button" @click="publicityRecord()">确 定</div>
      </div>
    </div>

  </div>
</template>

<script>
import { publicityRecord } from "@/api/api";
export default {
  data() {
    // 验证手机号
    const checkPhone = (rule, value, callback) => {
      const phoneReg = /^1[34578]\d{9}$/;
      if (phoneReg.test(value)) {
        callback();
      } else {
        callback(new Error("请输入正确的手机号码"));
      }
    };
    return {
      loading: false,
      form: {},
      rules: {
        name: [{ required: true, message: "请填写此必填项", trigger: "change" }],
        phone: [{ required: true, message: "请填写此必填项", trigger: "change" }, { validator: checkPhone }],
        email: [
          { required: true, message: "请填写此必填项", trigger: "change" },
          { type: "email", message: "电子邮件格式必须正确。", trigger: ["change"] }
        ],
        company: [{ required: true, message: "请填写此必填项", trigger: "change" }],
        position: [{ required: true, message: "请填写此必填项", trigger: "change" }]
      }
    };
  },
  methods: {
    publicityRecord() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true;

          let Form = {
            name: this.form.name,
            mobile: this.form.phone,
            mail: this.form.email,
            company: this.form.company,
            position: this.form.position
          };

          publicityRecord(Form).then(res => {
            if (res.code == 10000) {
              this.$router.push("/cn/activityFinished");
            } else {
              this.$message({
                message: "提交失败",
                type: "error",
                offset: 200
              }).$el;
              var el = document.querySelector(".el-message");
              if (el) {
                el.style.cssText = "z-index:500; min-width:380px;font-size:40px;height:50px";
              }
              return;
            }
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/.el-loading-spinner {
  font-size: 80px !important;
  .circular {
    width: 200px;
    height: 200px;
  }
}
img {
  pointer-events: none;
}
.main {
  background-image: url("https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/activity/activity.jpg");
  background-size: contain;
  min-height: 100%;
  overflow: hidden;
}
.img {
  text-align: center;
  padding-top: 200px;
  position: relative;
  z-index: 5;

  img {
    width: 90%;
  }
}

.gift {
  position: relative;
  img {
    width: 45%;
    position: absolute;
    z-index: 2;
    right: -100px;
    top: -250px;
    transform: rotate(30deg);
  }
}
.one {
  img {
    top: 0;
    left: -100px;
    z-index: 0;
  }
}
.two {
  img {
    top: 500px;
    left: -300px;
    z-index: 0;
    transform: rotate(10deg);
  }
}
.three {
  img {
    top: 1200px;
    left: 0px;
    z-index: 0;
    transform: rotate(10deg);
  }
}
.four {
  img {
    top: 1200px;
    right: -20px;
    z-index: 0;
    transform: rotate(10deg);
  }
}
.five {
  img {
    top: 500px;
    right: -220px;
    z-index: 0;
    transform: rotate(30deg);
  }
}
.box {
  //   padding: 200px;
  padding: 100px 0 50px 0;
  display: flex;
  justify-content: center;
}
.form {
  z-index: 1;

  background-color: #fff;
  padding: 10px 100px;
  padding-bottom: 0;
  width: 75%;
  //   border: 1px solid #000;
  box-shadow: 5px 5px 50px rgb(104, 103, 103);
  border-radius: 50px;
  .title {
    font-size: 60px;
    text-align: center;
    margin-bottom: 50px;
  }
  /deep/.el-form {
    // font-size: 90%;
    .el-form-item {
      .el-form-item__label::before {
        right: -40px;
        top: -10px;
      }
      .el-form-item__label {
        font-weight: 400;
        line-height: 100px;
        color: #868484;
        font-size: 60px;
      }
      .el-form-item__content {
        height: 200px;
        .el-form-item__error {
          font-size: 40px !important;
          top: 140px;
        }
        .el-input {
          //   border-radius: 50px;
          .el-input__inner {
            padding-left: 50px;
            background-color: #f6f7f9;
            border-radius: 30px;
            height: 130px;
            font-size: 70px;
          }
        }
      }
    }
  }
}
.true {
  display: flex;
  justify-content: center;

  text-align: center;
  .button {
    background-color: #fff;
    color: #0d62a9;
    font-weight: 700;
    box-shadow: 5px 5px 50px rgb(104, 103, 103);
    // background-color: #0d62a9;
    // border: 1px solid #000;
    border-radius: 50px;
    font-size: 80px;
    padding: 20px 0;
    width: 75%;
    margin-bottom: 50px;
  }
}
</style>